"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Alert_1 = require("./Alert");
const Icons_1 = require("../icon/Icons");
const { colorError, colorInfo, colorSuccess, colorWarning, filled, standard, outlined, icon, action, message } = Alert_1.alertClasses;
const { root: title } = Alert_1.alertTitleClasses;
const MuiAlertOverrides = {
    MuiAlert: {
        defaultProps: {
            variant: 'standard',
            severity: 'info',
            iconMapping: {
                info: react_1.default.createElement(Icons_1.InfoIcon, null),
                success: react_1.default.createElement(Icons_1.CheckCircleIcon, null),
                warning: react_1.default.createElement(Icons_1.WarningIcon, null),
                error: react_1.default.createElement(Icons_1.ErrorIcon, null),
            },
        },
        styleOverrides: {
            root: ({ theme }) => ({
                borderRadius: parseInt(`${theme.shape.borderRadius}`, 10) / 2,
                fontSize: theme.typography.body2.fontSize,
                fontWeight: theme.typography.fontWeightMedium,
                lineHeight: '24px',
                [`& .${icon}`]: {
                    color: 'inherit',
                    display: 'flex',
                    alignItems: 'center',
                    padding: '6px 0',
                },
                [`& .${action} `]: {
                    alignItems: 'center',
                },
                [`&.${title}`]: {
                    fontSize: theme.typography.fontSize,
                    fontWeight: theme.typography.fontWeightBold,
                },
                [`& .${message}`]: {
                    padding: '8px 0 4px',
                },
                // Variant styles
                [`&.${standard}`]: {
                    [`&.${colorInfo}`]: {
                        backgroundColor: theme.palette.blue[100],
                        color: theme.palette.blue[500],
                    },
                    [`&.${colorSuccess}`]: {
                        backgroundColor: theme.palette.green[100],
                        color: theme.palette.green[500],
                    },
                    [`&.${colorWarning}`]: {
                        backgroundColor: theme.palette.yellow[100],
                        color: theme.palette.yellow[700],
                    },
                    [`&.${colorError}`]: {
                        backgroundColor: theme.palette.red[100],
                        color: theme.palette.red[500],
                    },
                },
                [`&.${filled}`]: {
                    color: theme.palette.common.white,
                    [`&.${colorInfo}`]: {
                        backgroundColor: theme.palette.blue[700],
                    },
                    [`&.${colorSuccess}`]: {
                        backgroundColor: theme.palette.green[700],
                    },
                    [`&.${colorWarning}`]: {
                        backgroundColor: theme.palette.yellow[700],
                    },
                    [`&.${colorError}`]: {
                        backgroundColor: theme.palette.red[700],
                    },
                },
                [`&.${outlined}`]: {
                    backgroundColor: 'transparent',
                    borderWidth: 1,
                    [`&.${colorInfo}`]: {
                        color: theme.palette.blue[500],
                        borderColor: theme.palette.blue[500],
                    },
                    [`&.${colorSuccess}`]: {
                        color: theme.palette.green[500],
                        borderColor: theme.palette.green[500],
                    },
                    [`&.${colorWarning}`]: {
                        color: theme.palette.yellow[500],
                        borderColor: theme.palette.yellow[500],
                    },
                    [`&.${colorError}`]: {
                        color: theme.palette.red[500],
                        borderColor: theme.palette.red[500],
                    },
                },
            }),
        },
    },
};
exports.default = MuiAlertOverrides;
//# sourceMappingURL=MuiAlertOverrides.js.map